import Vue from 'vue'
import {
  Area,
  NumberKeyboard,
  Popup,
  Picker,
  DatetimePicker,
  Swipe,
  SwipeItem
} from 'vant'

import 'vant/lib/index.css'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
import http from './utils/http'
import { captureWechatEntryUrl } from './utils/wechat'
import { captureEntryDiagnostics } from './utils/entryDiagnostics'

function normalizeEmbeddedEntryUrl () {
  const currentPath = String(window.location.pathname || '')
  const currentHash = String(window.location.hash || '')
  if (currentHash) {
    return
  }
  const normalizedPath = ('/' + currentPath).replace(/\/+/g, '/').replace(/\/+$/, '') || '/'
  const supportedPaths = {
    '/': '/',
    '/home': '/home',
    '/login': '/login',
    '/consent': '/consent',
    '/consent-promotion': '/consent-promotion',
    '/intake': '/intake',
    '/success': '/success',
    '/report': '/report',
    '/projects': '/projects',
    '/pdf-preview': '/pdf-preview'
  }
  const targetPath = supportedPaths[normalizedPath]
  if (!targetPath) {
    return
  }
  const queryText = String(window.location.search || '')
  const nextUrl = `/#${targetPath}${queryText}`
  if (window.history && typeof window.history.replaceState === 'function') {
    window.history.replaceState(null, '', nextUrl)
    return
  }
  window.location.replace(nextUrl)
}

captureWechatEntryUrl()
captureEntryDiagnostics()
normalizeEmbeddedEntryUrl()

const App = require('./App').default
const router = require('./router').default

Vue.use(ViewUI)

Vue.use(Area)
Vue.use(NumberKeyboard)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(DatetimePicker)
Vue.use(Swipe)
Vue.use(SwipeItem)

Vue.prototype.$http = http
Vue.config.productionTip = false

const app = new Vue({
  el: '#app',
  router,
  render: h => h(App)
})

export default app



// WEBPACK FOOTER //
// ./src/main.js